module.exports = __webpack_public_path__ + "static/img/icon_achievement.becbf74.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_achievement.png
// module id = 4hHz
// module chunks = 1